/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from 'react';
import SalesAgreementListItem from './SalesAgreementListItem';
import { AgreementsListConatiner } from './ActiveAgreements';
import { SalesAgreement } from './storage';
import { TestIds } from '../../testIds';
import NoSalesAgreement from './NoSalesAgreement';
import { CONTACT_CARD_TITLE } from '../../util/consts';

interface PastAgreementsProps {
  pastAgreements: SalesAgreement[] | undefined;
}

const PastAgreementsTabPanel = ({ pastAgreements }: PastAgreementsProps) => {
  const isNoAgreement = React.useMemo(() => {
    return pastAgreements?.length === 0;
  }, [pastAgreements]);

  const renderBody = React.useMemo(() => {
    if (isNoAgreement) {
      return (
        <NoSalesAgreement
          body='You do not have any past Sales Agreements.'
          contactTitle={CONTACT_CARD_TITLE.underTabs}
        />
      );
    } else {
      return (
        <AgreementsListConatiner data-testid={TestIds.feat.agreement.tabView.pastAgreementsList}>
          {pastAgreements?.map((e) => (
            <SalesAgreementListItem
              key={e.id}
              {...e}
              products={e.lines.map((p) => p.productDescription)}
              percentageFulfilled={e.percentageFulfilled}
            />
          ))}
        </AgreementsListConatiner>
      );
    }
  }, [isNoAgreement, pastAgreements]);

  return renderBody;
};

export default PastAgreementsTabPanel;
